"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_UPGRADE_STEPS = exports.PageFormatChainError = void 0;
exports.applyPageUpgradeSteps = applyPageUpgradeSteps;
const page_document_maps_1 = require("./page-document-maps");
const page_layer_upgrade_1 = require("./page-layer-upgrade");
const page_structure_parts_upgrade_1 = require("./page-structure-parts-upgrade");
const page_structure_upgrade_1 = require("./page-structure-upgrade");
/** The upgrade chain or the stored format version cannot be applied. */
class PageFormatChainError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'PageFormatChainError';
    }
}
exports.PageFormatChainError = PageFormatChainError;
exports.PAGE_UPGRADE_STEPS = [
    { from: 1, to: 2, apply: page_structure_upgrade_1.upgradePageChildListsToTree },
    { from: 2, to: 3, apply: page_layer_upgrade_1.upgradePageBlockLayers },
    { from: 3, to: 4, apply: page_structure_parts_upgrade_1.upgradePageEntriesIntoParts },
];
/** Applies every remaining step and records each completed version. */
function applyPageUpgradeSteps(doc, steps = exports.PAGE_UPGRADE_STEPS) {
    if (!steps.length)
        throw new PageFormatChainError('Page upgrade chain is empty');
    for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        if (!Number.isInteger(step.from) ||
            !Number.isInteger(step.to) ||
            step.to <= step.from ||
            (i > 0 && steps[i - 1].to !== step.from)) {
            throw new PageFormatChainError('Page upgrade chain is not contiguous');
        }
    }
    let version = (0, page_document_maps_1.readPageFormatVersion)(doc);
    const target = steps[steps.length - 1].to;
    if (version === target)
        return;
    if (!steps.some(step => step.from === version)) {
        throw new PageFormatChainError(`Unsupported page format version: ${version}`);
    }
    doc.transact(() => {
        for (const step of steps) {
            if (step.from !== version)
                continue;
            step.apply(doc);
            (0, page_document_maps_1.setPageFormatVersion)(doc, step.to);
            version = step.to;
        }
    });
}
